"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applicabilityConfig;

function applicabilityConfig(_ref) {
  var ownerId = _ref.ownerId,
      objectType = _ref.objectType,
      subject = _ref.subject;
  return {
    ownerId: ownerId,
    objectType: objectType,
    subject: subject
  };
}

module.exports = exports.default;